jQuery(function($) {

  // Homepage hero slider
  $('.hero__slider').flickity({
    cellSelector: '.hero',
    imagesLoaded: true,
    setGallerySize: false,
    autoPlay: true,
    autoPlay: 6000
  });

  // Homepage news horizontal scroller
  $('.slideshow').flickity({
    imagesLoaded: true,
    pageDots: false,
    arrowShape: 'm79,8.3q0,1.3-1,2.3l-39,39,39,39q1,1,1,2.3t-1,2.3l-5,5q-1,1-2.3,1t-2.3-1l-47-46q-1-1-1-2.3t1-2.3l47-47q1-1,2-1,1.3,0,2.3,1l5,5q1,1,1,2.3z',
    cellAlign: 'left',
    contain: true

  });

  // Program Faculty Detail scroller
  var facultyGallery = $('.program__faculty__slider').flickity({
    cellSelector: 'img',
    imagesLoaded: true,
    arrowShape: 'm79,8.3q0,1.3-1,2.3l-39,39,39,39q1,1,1,2.3t-1,2.3l-5,5q-1,1-2.3,1t-2.3-1l-47-46q-1-1-1-2.3t1-2.3l47-47q1-1,2-1,1.3,0,2.3,1l5,5q1,1,1,2.3z'
  });

  var facultyCaption = $('.program__faculty__slider--caption');

  var flkty = facultyGallery.data('flickity');

  facultyGallery.on('cellSelect', function() {
    facultyCaption.text(flkty.selectedElement.alt);
  });

});
